.profilePicture {
    max-height: 50px;
    max-width: 50px;
    border-radius: 100%;
    margin-right: var(--mantine-spacing-sm);
}

.editButton {
    align-self: flex-end;
    margin-bottom: -30px;
}

.name {
    max-width: 200px;
    font-weight: 700;
}

.customerIdentifier {
    color: var(--mantine-color-dark-1);
    line-height: 20px;
}

.customerCaseNumber {
    line-height: 20px;
}

.root {
    justify-content: center;
    flex-direction: column;
}
